export default "__VITE_ASSET__DlEu5RW3__"